import React, { FC } from "react"
import { PhotoView } from "../../models/PhotoModel"
import { calcStandardTwoColumnLayout } from "../../libs/CalcPhotoLayout"
import { FigurePhoto } from "./FigurePhoto"
import { EditablePhoto } from "./PhotoLayout"

export const TwoRowsPhoto: FC<{ photos: PhotoView[] } & EditablePhoto> = ({
  photos,
  editable
}) => {
  const mainContainerClassName = "bl-photo__main-container"
  const subContainerClassName = `bl-photo__sub-container`

  const mainPhoto = photos[0]
  const subPhotos = photos.slice(1)

  const { mainWidthPercent, subWidthPercent } = calcStandardTwoColumnLayout(
    photos
  )

  return (
    <div className="bl-photo">
      <div
        style={{ flexBasis: mainWidthPercent + "%" }}
        className={mainContainerClassName}
      >
        <FigurePhoto
          editable={editable}
          key={mainPhoto.id}
          id={mainPhoto.id}
          url={mainPhoto.url}
          thumbnail={mainPhoto.thumbnail(800)}
          wrapped="main"
        />
      </div>
      <div
        style={{ flexBasis: subWidthPercent + "%" }}
        className={subContainerClassName}
      >
        {subPhotos.map(photo => (
          <FigurePhoto
            editable={editable}
            key={photo.id}
            id={photo.id}
            url={photo.url}
            thumbnail={photo.thumbnail(400)}
            wrapped="sub"
          />
        ))}
      </div>
    </div>
  )
}
